'use client'

import Link from 'next/link'
import { Badge } from '~/components/ui/catalyst/badge'
import { Divider } from '~/components/ui/catalyst/divider'
import { Heading } from '~/components/ui/catalyst/heading'
import { Text } from '~/components/ui/catalyst/text'
import { DisabledSpecCard } from './disabled-spec-card'
import { LazyImageDithering } from './lazy-image-dithering'
import { techSpecsGroups } from './tech-specs.data'

export function TechSpecs() {
  return (
    techSpecsGroups
      .filter(group => group.enabled)
      .map((group) => {
        const enabledSpecs = group.specializations.filter(spec => spec.enabled)
        const disabledSpecs = group.specializations.filter(spec => !spec.enabled)

        return (
          <div
            className={`
              space-y-4 rounded-[calc(var(--radius)+var(--padding))] bg-neutral-100 p-(--padding)
              [--padding:16px]
              [--radius:8px]
            `}
            key={group.id}
          >
            <div className="flex flex-col">
              <Heading level={3}>
                {group.title}
              </Heading>
              <Text className="text-muted-foreground">{group.description}</Text>
            </div>

            <Divider />

            <div className="grid grid-cols-1 gap-4 md:grid-cols-2 lg:grid-cols-3">
              {/* Enabled Specs */}
              {enabledSpecs.map(spec => (
                <Link
                  href="/waitlist"
                  className={`
                    relative overflow-hidden rounded-(--radius) bg-white py-0 transition-shadow duration-200 ease-in-out
                    hover:ring-2 hover:ring-sky-500
                  `}
                  key={spec.id}
                >
                  <div className={`
                    relative flex h-[240px] w-full items-center justify-center overflow-hidden bg-neutral-200
                  `}
                  >
                    <Badge color="zinc" className="absolute top-4 right-4 z-50 bg-neutral-200">
                      Обновлено
                      {' '}
                      {spec.lastUpdated}
                    </Badge>
                    <div className={`
                      absolute inset-0 z-10 size-full bg-linear-to-t from-white from-5% to-transparent to-90%
                    `}
                    />
                    <LazyImageDithering imagePath={spec.imagePath} />
                  </div>

                  <div className="space-y-6 p-4">
                    <div className="space-y-2">
                      <div className="text-2xl font-semibold">
                        {spec.title}
                      </div>
                      <Text className="text-sm text-neutral-600">
                        {spec.description}
                      </Text>
                    </div>

                    <Divider />

                    {/* Tech Stack */}
                    <div className="">
                      <div className="mb-2 text-xs font-semibold tracking-wide text-neutral-600 uppercase">
                        Технологии
                      </div>
                      <div className="relative">
                        <div className="flex gap-2 overflow-x-auto scrollbar-hide">
                          {spec.techIcons.map((icon) => {
                            const IconComponent = icon.component

                            return (
                              <Badge
                                key={icon.name}
                                color="zinc"
                                className="shrink-0 border bg-white"
                              >
                                <IconComponent
                                  size={14}
                                  className="shrink-0"
                                  style={{ color: icon.color }}
                                />
                                <span className="whitespace-nowrap">{icon.name}</span>
                              </Badge>
                            )
                          })}
                        </div>
                        <div className="pointer-events-none absolute top-0 right-0 h-full w-12 bg-gradient-to-l from-white to-transparent" />
                      </div>
                    </div>

                    {/* <Divider /> */}

                    {/* Companies */}
                    {/* <div>
                      <div className="mb-2 text-xs font-semibold tracking-wide text-neutral-600 uppercase">
                        Вопросы из компаний
                      </div>
                      <AvatarStack>
                        <Avatar>
                          <AvatarImage src="/assets/companies/yandex.png" />
                          <AvatarFallback>YA</AvatarFallback>
                        </Avatar>
                        <Avatar>
                          <AvatarImage src="/assets/companies/sber.png" />
                          <AvatarFallback>SB</AvatarFallback>
                        </Avatar>
                        <Avatar>
                          <AvatarImage src="/assets/companies/wb.jpg" />
                          <AvatarFallback>WB</AvatarFallback>
                        </Avatar>
                        <Avatar>
                          <AvatarImage src="/assets/companies/ozon.jpeg" />
                          <AvatarFallback>OZ</AvatarFallback>
                        </Avatar>
                        <Avatar>
                          <AvatarImage src="/assets/companies/avito.jpg" />
                          <AvatarFallback>AV</AvatarFallback>
                        </Avatar>
                        <Avatar>
                          <AvatarImage src="/assets/companies/alfabank.jpg" />
                          <AvatarFallback>AB</AvatarFallback>
                        </Avatar>
                        <Avatar>
                          <AvatarImage />
                          <AvatarFallback>4</AvatarFallback>
                        </Avatar>
                      </AvatarStack>
                    </div> */}

                    <Divider />

                    {/* Questions Stats */}
                    <div className="flex gap-2">
                      <Badge color="zinc" className="px-2 sm:text-base/6">
                        {spec.questionCount}
                        {' '}
                        вопросов
                      </Badge>

                      <Badge color="zinc" className="px-2 sm:text-base/6">
                        {spec.interviewCount}
                        {' '}
                        интервью
                      </Badge>
                    </div>
                  </div>
                </Link>
              ))}

              {/* Disabled Specs */}
              {disabledSpecs.map(spec => (
                <DisabledSpecCard
                  key={spec.id}
                  id={spec.id}
                  title={spec.title}
                  description={spec.description}
                  imagePath={spec.imagePath}
                  techIcons={spec.techIcons.map(icon => ({
                    name: icon.name,
                    color: icon.color,
                  }))}
                />
              ))}
            </div>
          </div>
        )
      })
  )
}
